import { api } from './client';
import type { AppLikeOverviewParams, AppLikeOverviewResponse } from './applovinDashboard';

interface ApiEnvelope<T> {
  code: number;
  message: string;
  data: T;
}

export interface RtbEfficiencyParams extends AppLikeOverviewParams {
	/** 周、月投入效率可按日期与国家/地区的任意组合展开。 */
	dimensions?: string;
	country?: string;
}

export const rtbDashboardApi = {
  // Zeelool's legacy RTB dashboard continues to use the original overview API.
  getOverview: (params: AppLikeOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/rtb/overview', { params }),
  getEfficiency: (params: RtbEfficiencyParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/rtb/overview', { params }),
  getTrend: (params: AppLikeOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/rtb/trend', { params }),
};
